/**
 * The single schedule phrase both routine surfaces render — the editor's trigger-block summary and the
 * list's schedule chip. Carries no sentence lead ("daily at 09:00 (UTC)") so the editor can prefix
 * "Runs " and the list can capitalize it; wording and new cadences change here once, not in two places.
 */
import type { Schedule } from '../types';

/** Lead-less, lowercase-initial phrase, e.g. `weekly on Monday at 09:00 (UTC)`. */
export function schedulePhrase(schedule: Schedule): string {
  const at = `at ${schedule.time} (${schedule.timezone})`;
  // The switch is exhaustive over `Cadence` — a new cadence fails to compile until it gets its wording.
  switch (schedule.cadence) {
    case 'manual':
      return 'on demand';
    case 'hourly':
      return `hourly (${schedule.timezone})`;
    // weekly pins to Monday (day-of-week 1 in cadenceToCron); monthly pins to the 1st.
    case 'weekly':
      return `weekly on Monday ${at}`;
    case 'monthly':
      return `monthly on the 1st ${at}`;
    case 'weekdays':
      return `weekdays ${at}`;
    case 'daily':
      return `daily ${at}`;
  }
}

/** Sentence-case form for standalone use (list chips): `Weekly on Monday at 09:00 (UTC)`. */
export function scheduleLabel(schedule: Schedule): string {
  const phrase = schedulePhrase(schedule);
  return phrase.charAt(0).toUpperCase() + phrase.slice(1);
}
